import { useEffect, useState } from "react";
import { useSession } from "../../../hooks/useSession";
import { useRecapIcons } from "../../../hooks/useRecapIcons";
import { ApiService as api } from "../../../services/ApiService";
import { useEditAppointment } from "../../../hooks/useEditAppointment";
import { useDynatrace } from "../../../hooks/useDynatrace";

export const useRiepilogoPage = () => {
  const { read, update, getAppointmentPayload, reloadAppOnBack } = useSession();
  const { onShowMapClick, onGetDirectionsClick, onPrintClick, onDownloadPdfClick, onSaveToICalClick } = useRecapIcons();
  const { showModal, closeModal, setCodiceFiscale, codiceFiscale, codiceFiscaleError, askForEditAppointment, busy } = useEditAppointment();

  const [isSendAuditBusy, setIsSendAuditBusy] = useState(false);
  const [isSendAuditError, setIsSendAuditError] = useState(false);
  const [auditSent, setAuditSent] = useState(false);

  useEffect(() => {
    reloadAppOnBack();
  }, []);

  const {} = useDynatrace();

  const onAuditChange = (field, value) => {
    update(field, value);
  };

  const sendAuditAnswers = async () => {
    const payload = getAppointmentPayload();

    if (payload.consolidamento == -1 || payload.impiego == -1) {
      setIsSendAuditError(true);
      return;
    }

    setIsSendAuditError(false);
    setIsSendAuditBusy(true);
    try {
      await api.sendAudit(payload);
    } catch (error) {}
    setAuditSent(true);
    setIsSendAuditBusy(false);
  };

  return {
    read,
    onShowMapClick,
    onGetDirectionsClick,
    onPrintClick,
    onDownloadPdfClick,
    onSaveToICalClick,
    auditSent,
    sendAuditAnswers,
    onAuditChange,
    isSendAuditError,
    isSendAuditBusy,
    askForEditAppointment,
    codiceFiscaleError,
    busy,
  };
};
